import { RsvpFormSharedState } from './RsvpForm/RsvpFormModel'

export class BangaloreState
{
  public screenIsNarrow?: boolean
  public formIsOpen = false
  public rsvpFormState = new RsvpFormSharedState()
}
